import { Component, type ErrorInfo, type ReactNode } from 'react';
import { reportError } from '../net/telemetry';

/** Last line of defence: reports a crash and offers a reload instead of a blank page. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { crashed: boolean }> {
  override state = { crashed: false };

  static getDerivedStateFromError() {
    return { crashed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    reportError('react', error, info.componentStack?.split('\n').find((l) => l.trim())?.trim());
  }

  override render() {
    if (!this.state.crashed) return this.props.children;
    return (
      <div className="welcome">
        <section className="panel narrow" role="alert">
          <h2>Oops! Something went wrong.</h2>
          <p>We've let the Buddy Bay team know. Reloading the page usually fixes it.</p>
          <button className="btn wide" onClick={() => window.location.reload()}>Reload</button>
        </section>
      </div>
    );
  }
}
